<template>
  <div
    class="m-pc-partner top-nav"
    id="partner"
    v-if="extras.partner.display == 1 && columns.length > 0"
  >
    <Title
      v-if="extras.partnerTitle.display == 1"
      :title="extras.partnerTitle.model || title"
    />
    <div
      class="g-partner-content u-w1200"
    >
      <div
        class="g-parter-details"
        v-for="(item1, index) in columns"
        :key="index"
      >
        <div
          class="m-tab-list swiper-list"
          v-if="
            columns.length > 1 || (columns.length == 1 && columns[0].id != 0)
          "
        >
          <!--大于1必显示，只有一个目录的时候不是主目录也要显示-->
          <div class="swiper-container swiper2">
            <div class="swiper-wrapper btnevent">
              <div
                class="tab gu-width swiper-slide u-mr26 active"
                :class="{
                  'cursor-default': isSetting == 1,
                }"
              >
                {{ item1.name }}
              </div>
            </div>
          </div>
        </div>

        <div class="g-par-box" id="partners">
          <div class="g-partner-list">
            <div
              class="list pull-left"
              v-for="(item, i) in item1.article"
              :key="i"
            >
              <div
                v-if="
                  extras &&
                  extras.partnerCover &&
                  extras.partnerCover.display == 1
                "
                class="g-details-left pull-left"
                :class="{
                  'cursor-default': isSetting == 1,
                }"
                @click="didClickPartner(item)"
              >
                <img
                  :src="
                    item.coverImageRealPath
                      ? item.coverImageRealPath
                      : require('@/assets/images/defPartner.png')
                  "
                />
              </div>
              <div
                class="g-details-right"
                :style="{
                  height: extras.partnerSummary.display == 1 ? '100px' : '',
                }"
                v-if="
                  extras.partnerContentTitle.display == 1 ||
                  extras.partnerSummary.display == 1
                "
              >
                <div
                  class="g-right-top u-mb10"
                  v-if="extras.partnerContentTitle.display == 1"
                >
                  {{ item.name }}
                </div>
                <div
                  class="g-right-bottom"
                  v-if="extras.partnerSummary.display == 1"
                >
                  {{ item.desc }}
                </div>
              </div>
            </div>
          </div>
          <!--<ol class="m-btn-list parBtns"></ol>-->
          <div class="m-nodata-body" v-if="item1.article && item1.article.length == 0">
            <img src="@/assets/images/nodata.png" />
            <div class="m-nodata">暂无数据</div>
          </div>
          <!--<div class="g-news-bottom" v-if="articles.length > 12">-->
            <!--<div-->
              <!--:class="isShowMore == false ? 'g-more-news' : ' g-more-news-up'"-->
              <!--@click="showMoreArticle"-->
            <!--&gt;-->
              <!--更多合作伙伴-->
            <!--</div>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <!--合作伙伴弹窗-->
    <div class="g-popup" v-if="popShow">
      <div class="popup-block">
        <!--        <div class="block-close" @click="didClickCloseImg">-->
        <!--          <img class="close-img" />-->
        <!--        </div>-->

        <span
          class="icon icontemp stemp-close"
          @click="didClickCloseImg"
        ></span>
        <div class="block-content">
          <img
            :src="
              popData.coverImageRealPath
                ? popData.coverImageRealPath
                : require('@/assets/images/defaultPar.jpg')
            "
          />
          <div class="content-text">
            <div class="text-title">{{ popData.name }}</div>
            <div class="text-desc">{{ popData.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/index/Title.vue";
import { URLS } from "fire-wind-water";

export default {
  components: {
    Title,
  },
  props: {
    partnerInfo: [],
    extras: Object,
  },
  data() {
    return {
      title: "合作伙伴",
      isSetting: 0,
      currentId: 0,
      columns: [],
      articles: [],
      isShowMore: false,
      popShow: false,
      popData: null,
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  mounted() {
    console.log("pc-partner", this.partnerInfo);
    //this.initColumns();

    let tempColumns = this.getColumns.articleInitColumns(
      this.partnerInfo.column,
      this.partnerInfo.article,
      "合作伙伴",
      true
    );
    this.columns = tempColumns;
    debugger
    this.articles = this.columns.length > 0 ? this.columns[0].article : [];
  },
  methods: {
    initColumns() {
      let tempArticles = this.partnerInfo.article;
      let tempColumns = this.partnerInfo.column;
      // if (tempColumns.length == 0) {
      //   return;
      // }
      const columns = [
        {
          id: 0,
          name: "合作伙伴",
          article: tempArticles,
        },
      ];
      for (let i in tempArticles) {
        let c = tempArticles[i].desc ? tempArticles[i].desc.substr(0, 130) : "";
        tempArticles[i].desc = c;
      }
      for (let i in tempColumns) {
        columns.push(tempColumns[i]);
      }
      this.columns = columns;
      // this.currentId = this.columns[0].id;
      this.articles = this.columns[0].article;
    },
    columnClick(item, idx) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.currentId = idx;
      this.articles = item.article;
    },
    showMoreArticle() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowMore = !this.isShowMore;
    },
    didClickPartner(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      console.log(item);
      //      this.popShow = true;
      //      this.popData = item;
      if (
        item.linkUrl != "" &&
        item.linkUrl != "https://" &&
        item.linkUrl != "http://"
      )
        window.open(item.linkUrl);
    },
    didClickCloseImg() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.popShow = false;
      this.popData = null;
    },
  },
};
</script>
<style scoped></style>
